var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions as connectionsActions } from "../../Connections";
import { openPanel } from "../actions/uiActions";
import ShowIf from "../../App/ShowIf";
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

import { addToToc } from "../actions/documentActions";

export class ViewerTextSelectedMenu extends Component {
  showPanel(type) {
    this.props.openPanel('viewMetadataPanel');
    this.props.startNewConnection(type, this.props.doc.get('sharedId'));
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: this.props.active ? 'active' : '' }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.hasRelationTypes }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary connect-to-p",
        onClick: this.showPanel.bind(this, 'targetRanged') }, void 0, /*#__PURE__*/

      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Connect to a paragraph")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "paragraph" })
      )
      ), /*#__PURE__*/
      _jsx(ShowIf, { if: this.props.hasRelationTypes }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary connect-to-d",
        onClick: this.showPanel.bind(this, 'ranged') }, void 0, /*#__PURE__*/

      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Connect to a document")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "file" })
      )
      ), /*#__PURE__*/
      _jsx("div", {
        className: "btn btn-primary add-toc",
        onClick: this.props.addToToc.bind(null, this.props.reference.toJS(), this.props.file.toc) }, void 0, /*#__PURE__*/

      _jsx("span", { className: "ContextMenu-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add to table of contents")
      ), /*#__PURE__*/
      _jsx(Icon, { icon: "font" })
      )
      ));

  }
}












function mapStateToProps({ documentViewer, relationTypes }) {
  return {
    doc: documentViewer.doc,
    reference: documentViewer.uiState.get('reference'),
    hasRelationTypes: !!relationTypes.size
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      startNewConnection: connectionsActions.startNewConnection,
      openPanel,
      addToToc
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewerTextSelectedMenu);